import { useEffect, useState } from 'react';
import { getMappingsInPostgre, IMappingsAnalyticsPayload } from 'wisestep-api';

import { useComposableDashboardsFiltersContext } from '../../analyticsPage/hooks/useComposableDashboardsFiltersContext';
import { IPostgreMappingsDTO } from '../BaseCharts/mappings/types';
import { getDateRangeByTimePeriod } from '../utils/timeInfo';
const defaultWidgetResponse: IPostgreMappingsDTO = {
  count: 0,
  response: [],
  data: [],
  categories: [],
  series: [],
  resultSet: [],
};
const usePostgreMappingWidgetData = (query: IMappingsAnalyticsPayload) => {
  const [widgetData, setWidgetData] = useState<IPostgreMappingsDTO>(defaultWidgetResponse);
  const { restructuredFilters } = useComposableDashboardsFiltersContext();

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const response = await getMappingsInPostgre(
          {
            ...query,
            filters: [...(query.filters ?? []), ...restructuredFilters],
            ...getDateRangeByTimePeriod(query.range as string),
          },
          { signal: controller.signal } as AbortController
        );
        setWidgetData({
          ...response?.data,
          resultSet: response?.data?.resultSet?.map((item) => ({
            ...item,
            candidateStatus: query.candidateStatusTags?.[0] ?? '',
          })),
        });
      } catch (error) {
        console.error('Mappings composable analytics data fetch error', error);
      }
    })();

    return () => controller.abort();
  }, [query, restructuredFilters]);

  return { widgetData };
};

export default usePostgreMappingWidgetData;
